import React from "react";
import { usePageContent } from '../../hooks/usePageContent';

const PrivacyCollectionNoticePage = () => {
  const { find } = usePageContent('privacy-collection-notice');
  const c = find('richText') || {};
  return (
    <div id="content">
      <div className="content-holder content-holder--indented">
        <div className="rich-text" dangerouslySetInnerHTML={{ __html: c.richTextHtml || '' }} />
      </div>
    </div>
  );
};

export default PrivacyCollectionNoticePage;
